import React, { Component } from 'react';
import {NavLink} from 'react-router-dom';
import { findDOMNode } from 'react-dom';
import $ from "jquery";

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Tooltip from '@material-ui/core/Tooltip';

import {booleanConvert, stableSort, getSorting} from '../Common/helpers';
import EnhancedTableHead from '../Common/TableHead/EnhancedTableHead';
import ModalBox from '../Common/Modals/ModalBox';
import Search from '../Common/Search/Search';

import { API } from '../../ws/constants';

class Communications extends Component {
    state = {
        fetchData:null
        ,fetchTypes:null
        ,openModal:false
        ,order:'asc'
        ,orderBy:'StaffId'
        ,page:0
        ,rowsPerPage:10
        ,tableLoading:false
        ,returnTitle: "Erro"
        ,returnText: "Ocorreu algum erro"
        ,communicationTypeId:""
        ,returnType: 1
    };

    componentDidMount() {
        Promise.all([
            fetch(API + "getcommunications")
            ,fetch(API + "getcommunicationtypes")
        ])
        .then(responses => Promise.all(responses.map(r => r.json())))
        .then((data) => {
            this.setState({
              fetchData: data[0]
              , fetchTypes: data[1].data
            });
        });
    }

    deleteRow = (communicationId) => {
        if(window.confirm("Tem a certeza que quer apagar esta mensagem?")){
            this.setState({tableLoading:true});
            fetch(API + 'deletecommunication&communicationid=' + communicationId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, tableLoading:false });
                $(findDOMNode(this.refs["communicationId_" + communicationId])).remove();
            });
        }
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
    }
    
    handleCommunicationTypeChange = (e, el) => {
        const value = e.target.value;
        this.setState({ [e.target.name]: value, somethingWasEdited:true}, this.handleFilters);
    };

    handleFilters = () => {
        let searchURL = API + "searchcommunications";

        const filters = [];
        const values = [];

        filters.push("filterbytypeid");
        values.push(this.state.communicationTypeId);

        for(var i=0,n=filters.length;i<n;i++)
            searchURL += "&"+filters[i]+"="+values[i];

        fetch(searchURL)
        .then(response => response.json())
        .then(data => this.setState({ fetchData: data }));
    }

    handleSearch = (search) => {
        this.setState({ tableLoading:true, page: 0 });
        fetch(API + "searchcommunications&keyword="+search)
        .then(response => response.json())
        .then(data => this.setState({ tableLoading:false, fetchData: data }));
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        this.setState({ order, orderBy });
    };

    renderFilterTypeOptions = (e) => {
        const type = this.state.fetchTypes;
        if(type===null)
            return;

        const items = [<MenuItem value="0" key="0">Todos os tipos</MenuItem>];
        for (let i=0,n=type.length;i<n;i++) {
            items.push(<MenuItem value={type[i].Id}
                                 key={type[i].Id}>{type[i].Name}</MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData } = this.props;
        const communications = this.state.fetchData!==null ? this.state.fetchData.data : []
              , optsCommunicationTypes = this.renderFilterTypeOptions()
              , loadingClass = this.state.tableLoading ? " ajaxLoading" : ""
              , { order, orderBy, rowsPerPage, page } = this.state
              , headerRows = [
                  { id: 'TypeName', active: true, numeric: false, label: 'Tipo' },
                  { id: 'Name', numeric: false, label: 'Designação' },
                  { id: 'Sender', numeric: false, label: 'Remetente' },
                  { id: 'Subject', numeric: false, label: 'Assunto' },
                  { id: 'Description', numeric: false, label: 'Descrição' },
                  { id: 'IsActive', numeric: false, className: 'smallerHeader', label: 'Ativo' },
                  { id: 'actions', notSortable: true, label: 'Ações' },
              ];

        return (
            <div id="communicationCenterPage">
                <div>
                    <div className="row">
                        <Search searchCallback={this.handleSearch}
                                className="col-12 col-md-4"/>
                    </div>
                    <div className="row">
                        <div className="fieldHolder selectField col-12 col-md-4">
                            <FormControl fullWidth={true}>
                                <InputLabel htmlFor="communicationTypeId">Tipos de Comunicação</InputLabel>
                                <Select id="communicationTypeId"
                                        name="communicationTypeId"
                                        value={this.state.communicationTypeId}
                                        onChange={this.handleCommunicationTypeChange}>
                                  {optsCommunicationTypes}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="pageHeader">
                        <h1>
                            <i className="fa fa-mail-bulk"></i> Comunicações <span className="arrayCount">({communications.length})</span>
                            { (isAdmin || (loginData.profile.Communications && loginData.profile.Communications.ADD)) && 
                                <span className="float-right">
                                    <Tooltip
                                        title={"Adicionar Comunicação"}
                                        enterDelay={200}>
                                        <span><NavLink className="actionButton success" to={"/Communications/New"}><i className="fa fa-plus"></i></NavLink></span>
                                    </Tooltip>
                                </span>
                            }
                        </h1>
                    </div>
                    <Table className={"responsiveTable customTable" + loadingClass}>
                        <EnhancedTableHead
                            className="tableRow tableHeader"
                            headerRows={headerRows}
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                            rowCount={communications.length}>
                        </EnhancedTableHead>
                        <TableBody>
                            {stableSort(communications, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(communication =>
                            <TableRow key={communication.Id} className={"tableRow" + (communication.IsSystem ? " dangerBorder" : "")} ref={"communicationId_" + communication.Id}>
                                <TableCell data-title="Tipo" className="tableCell">{communication.TypeName}</TableCell>
                                <TableCell data-title="Designação" className="tableCell">{communication.Name}</TableCell>
                                <TableCell data-title="Remetente" className="tableCell">{communication.Sender}</TableCell>
                                <TableCell data-title="Assunto" className="tableCell">{communication.Subject}</TableCell>
                                <TableCell data-title="Descrição" className="tableCell">{communication.Description}</TableCell>
                                <TableCell data-title="Ativo" className="tableCell">{booleanConvert(communication.IsActive)}</TableCell>
                                <TableCell data-title="Ações" className="tableCell actions" data-row-id={communication.Id}>
                                    {(isAdmin || (loginData.profile.Communications && loginData.profile.Communications.permission === 1)) &&
                                        <Tooltip
                                            title={"Editar Comunicação"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton warning" to={"/Communications/"+communication.Id}><i className="fa fa-pencil-alt"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {(loginData.profile.Communications && loginData.profile.Communications.permission === 2) &&
                                        <Tooltip
                                            title={"Ver Comunicação"}
                                            enterDelay={200}>
                                            <span><NavLink className="actionButton success" to={"/Communications/"+communication.Id}><i className="fa fa-eye"></i></NavLink></span>
                                        </Tooltip>
                                    }
                                    {((communication.IsSystem && loginData.AccessLevel < 1) || (!communication.IsSystem && (isAdmin || loginData.profile.Communications.DEL))) &&
                                        <Tooltip
                                            title={"Eliminar Comunicação"}
                                            enterDelay={200}>
                                            <span><button type="button" className="simpleBtn actionButton danger" onClick={() => this.deleteRow(communication.Id)}><i className="fa fa-times"></i></button></span>
                                        </Tooltip>
                                    }
                                </TableCell >
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
				</div>
                <div className="row">
                    <div className="col-12">
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={communications.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage="Linhas por página:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Página anterior',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Próxima página',
                            }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        />
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default Communications;
